import { render, staticRenderFns } from "./site-footer.vue?vue&type=template&id=63a5b287&scoped=true&"
import script from "./site-footer.vue?vue&type=script&lang=js&"
export * from "./site-footer.vue?vue&type=script&lang=js&"
import style0 from "./site-footer.vue?vue&type=style&index=0&id=63a5b287&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a5b287",
  null
  
)

export default component.exports